export default __webpack_public_path__ + "static/media/brand-6.2e9ed3d2.png";